export default __webpack_public_path__ + "static/property-overview-4-978613be2378013f9265f3850c4b4739.png";